import clsx from 'clsx';
import ReactPlayer from 'react-player';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';

interface Props {
  open: boolean;
  url: string;
  onOpenChange: (nextOpen: boolean) => void;
}

const VideoDialog = (props: Props) => {
  const { open, url, onOpenChange } = props;

  return (
    <Dialog
      open={open}
      onOpenChange={nextOpen => {
        onOpenChange(nextOpen);
      }}
    >
      <DialogContent
        className={clsx('h-full w-full max-w-none p-0 ', 'bg-black/20', 'max-h-full overflow-auto ')}
        aria-describedby={undefined}
      >
        <DialogTitle className='hidden'>video dialog</DialogTitle>
        <div
          className={clsx(' h-full ', 'flex items-center justify-center')}
          onClick={() => {
            onOpenChange(false);
          }}
        >
          <div
            className={clsx(' w-full max-w-[800px]  ')}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div className={clsx(' relative  ')}>
              <button
                type='button'
                className={clsx(
                  ' absolute -top-2.5 right-2.5 h-10 w-10 -translate-y-full lg_-right-10 lg_-top-10 lg_-translate-y-0 ',
                  'after_h-0.5 after_w-8 after_bg-white after_content-[""] ',
                  'after_absolute after_left-1/2 after_top-1/2 after_-translate-x-1/2 after_-translate-y-1/2',
                  'before_h-0.5 before_w-8 before_bg-white before_content-[""] ',
                  'before_absolute before_left-1/2 before_top-1/2 before_-translate-x-1/2 before_-translate-y-1/2',
                  'before_-rotate-45 after_rotate-45',
                  'before_duration-200 before_transition-transform before_ease-in-out',
                  'after_duration-200 after_transition-transform after_ease-in-out',
                  ' hover_before_rotate-[45deg] hover_after_rotate-[135deg]',
                )}
                onClick={() => {
                  onOpenChange(false);
                }}
              />
            </div>

            <div className={clsx(' relative w-full pb-[56.25%]')}>
              <div className={clsx(' absolute left-0 top-0 z-[5]', 'h-full w-full')}>
                <ReactPlayer
                  loop
                  url={url}
                  width={'100%'}
                  height={'100%'}
                  playbackRate={1}
                  playsinline={false}
                  controls
                  playing
                />
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VideoDialog;

export type { Props as VideoGalleryDialogProps };
